import './index.css'
import * as React from 'react'
import HelpTooltip from 'components/common/tooltip'
import ChangeIndicator from './change-indicator'
type FormFieldOptions = {
  showIcon?: boolean
  tooltipId?: string
  tooltipContents?: string
}
type Props = {
  beforeLabel?: React.ReactNode
  className?: string
  fieldName: string
  label: string
  labelIcon?: React.ReactNode
  options: FormFieldOptions
  helpText?: React.ReactNode
  component: React.ReactNode
  showDifference: boolean | null | undefined
  metadata: Record<string, any>
  originalMetadata: Record<string, any> | null | undefined
}

const FormField = ({
  className,
  beforeLabel,
  helpText,
  fieldName,
  label,
  labelIcon,
  options,
  metadata,
  originalMetadata,
  component,
  showDifference,
}: Props): React.ReactElement<'div'> => {
  const { showIcon, tooltipId, tooltipContents } = options
  return (
    <div className={className}>
      <label className="Form_Label EditMetadata_Label flc" title={label}>
        {beforeLabel && (
          <div className="EditMetadata_BeforeLabel">{beforeLabel}</div>
        )}
        <span className="EditMetadata_LabelText">{label}</span>
        {labelIcon && (
          <span className="EditMetadata_LabelIcon">{labelIcon}</span>
        )}
        {(tooltipId || tooltipContents) && (
          <HelpTooltip id={tooltipId}>{tooltipContents}</HelpTooltip>
        )}
        {showIcon && showDifference && (
          <div className="EditMetadata_Label_Icon">
            <ChangeIndicator
              field={fieldName}
              metadata={metadata}
              originalMetadata={originalMetadata}
            />
          </div>
        )}
      </label>
      {component}
      {helpText}
    </div>
  )
}

export default FormField
